export default __webpack_public_path__ + "static/media/iconSubArea.2094f69f.svg";